import { TRole } from "../model/IRole";

// --
export type TPageUrl =
| '/oauth/signIn'
| '/orders'
| '/orders-by-date'
| '/orders-by-vendor'
| '/orders-by-vehicle'
| '/orders-by-part-type'
| '/orders-by-status'
| '/orders-by-website'
| '/orders-by-state'
| '/orders-by-dma'
| '/orders-by-payment-type'
;

type IAccess<T extends string | number | symbol> = {
  [key in T]: (Partial<TRole | '*'>)[];
};

// --
// -- Access map
// --
// -- '*' is never a role a user actually holds, so a page listing only '*' is
// -- reachable but never "granted" - the sign in route does not gate on access.
// --
export const pagesAccess: IAccess<TPageUrl> = {
  '/oauth/signIn':   ['*'],
  '/orders':         ['ROLE_ADMIN', 'ROLE_AGENT'],
  '/orders-by-date':   ['ROLE_ADMIN', 'ROLE_AGENT'],
  '/orders-by-vendor':  ['ROLE_ADMIN', 'ROLE_AGENT'],
  '/orders-by-vehicle':   ['ROLE_ADMIN', 'ROLE_AGENT'],
  '/orders-by-part-type': ['ROLE_ADMIN', 'ROLE_AGENT'],
  '/orders-by-status':    ['ROLE_ADMIN', 'ROLE_AGENT'],
  '/orders-by-website':   ['ROLE_ADMIN', 'ROLE_AGENT'],
  '/orders-by-state':     ['ROLE_ADMIN', 'ROLE_AGENT'],
  '/orders-by-dma':       ['ROLE_ADMIN', 'ROLE_AGENT'],
  '/orders-by-payment-type': ['ROLE_ADMIN', 'ROLE_AGENT'],
};
